import { map, toArray, switchAll, flatMap, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of, concat, from } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Station, TransportCreationProfile } from '../model/station.model';

@Injectable({
    providedIn: 'root'
})

export class StationService {
    constructor(private http: HttpService) { }

    getStations(): Observable<Station[]> {

        return this.http.postWithContext<Station[]>(environment.stationsAdminEndpoint + '/stations', {})
            .pipe(
                mergeMap(x => x),
                map(station => {
                    const newStation = new Station(station);
                    return newStation;
                }),
                toArray()
            );
    }

    createStation(station: Station): Observable<Identity> {
        return this.http.postWithContext<Identity>(environment.stationsAdminEndpoint + '/create', station);
    }

    updateStation(station: Station): Observable<ServiceResponse> {
        return this.http.postWithContext<ServiceResponse>(environment.stationsAdminEndpoint + '/update', station);
    }

    deleteStation(identity: Identity): Observable<ServiceResponse> {
        return this.http.postWithContext<ServiceResponse>(environment.stationsAdminEndpoint + '/delete', identity);
    }

    getTransportCreationProfiles(): Observable<TransportCreationProfile[]> {
        return this.http.postWithContext<TransportCreationProfile[]>(environment.stationsAdminEndpoint + '/transport-creation-profiles', {})
            .pipe(
                mergeMap(x => x),
                map(station => new TransportCreationProfile(station)),
                toArray()
            );
    }
}
